import { useBreakpoint } from '@ocean/hooks'
import { LayoutProps, ModalConfirmationLayoutSegmentProps } from 'layouts/types'
import withLayout from 'layouts/withLayout'
import {
  Wrapper,
  CustomScrollbars as Scrollbars,
  Content,
  FillContent,
  ActionsWrapper,
} from './ModalConfirmationLayout.styled'

export type ModalConfirmationLayoutSegments = 'content' | 'fill' | 'actions'
type InternalLayoutProps = LayoutProps<ModalConfirmationLayoutSegments>

export const ModalConfirmationLayoutSegment: React.FC<ModalConfirmationLayoutSegmentProps> = ({
  children,
}) => <>{children}</>

const ModalConfirmationLayout = ({ segments }: InternalLayoutProps) => {
  const isDesktop = useBreakpoint('sm')
  return (
    <Wrapper>
      {segments?.content && (
        <Scrollbars autoHeight={isDesktop} autoHeightMax={isDesktop ? '50vh' : undefined} sticky>
          <Content>{segments.content}</Content>
        </Scrollbars>
      )}
      {segments?.fill && <FillContent>{segments.fill}</FillContent>}
      {segments?.actions && <ActionsWrapper>{segments.actions}</ActionsWrapper>}
    </Wrapper>
  )
}

export default withLayout(ModalConfirmationLayout)
